function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F16718",
  fillRule: "nonzero",
  d: "M6.205 10.2c.11 0 .173-.066.173-.18V5.204c0-.047.027-.076.073-.076h1.466c.11 0 .173-.066.173-.179V3.78c0-.113-.064-.179-.173-.179H3.173c-.11 0-.173.066-.173.18v1.168c0 .113.064.18.173.18h1.42c.046 0 .073.028.073.075v4.818c0 .113.064.179.173.179h1.366zm3.943 0c.109 0 .173-.066.173-.18V6.694c0-.076.054-.085.09-.029l.565.971a.222.222 0 00.21.123h.637a.222.222 0 00.21-.123l.564-.97c.037-.057.091-.048.091.028v3.328c0 .113.064.179.173.179h1.366c.11 0 .173-.066.173-.18V3.78c0-.114-.064-.18-.173-.18H12.87a.222.222 0 00-.21.123l-1.1 1.857c-.028.057-.083.057-.11 0l-1.102-1.857a.222.222 0 00-.21-.123H8.783c-.11 0-.173.066-.173.18v6.24c0 .114.064.18.173.18h1.366z"
}));

function SvgTypemaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypemaster);
export default __webpack_public_path__ + "static/media/typemaster.a31ba959.svg";
export { ForwardRef as ReactComponent };